import { useEffect } from "react";
import PublicHeader from "../components/PublicHeader";
import PublicFooter from "../components/PublicFooter";

export default function MentionsLegales() {
  useEffect(() => {
    document.title = "Mentions légales · FlowMind AI";
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <PublicHeader />
      <section className="max-w-3xl mx-auto px-6 py-20" data-testid="mentions-legales-page">
        <span className="overline">Informations légales</span>
        <h1 className="font-display text-5xl font-medium tracking-tighter mt-4 mb-4">Mentions légales</h1>
        <p className="text-sm text-zinc-500 mb-12">Dernière mise à jour : 10 février 2026</p>

        <article className="prose prose-zinc max-w-none">
          <h2 className="font-display text-2xl font-medium tracking-tight mt-10 mb-4">1. Éditeur du site</h2>
          <p className="text-zinc-700 leading-relaxed">
            Le site <strong>flowmindai.eu</strong> est édité par :
          </p>
          <ul className="list-disc pl-6 text-zinc-700 space-y-1 mt-3">
            <li><strong>Dénomination sociale</strong> : FlowMind AI SAS</li>
            <li><strong>Forme juridique</strong> : Société par Actions Simplifiée</li>
            <li><strong>Capital social</strong> : 10 000 €</li>
            <li><strong>Siège social</strong> : 1 rue de Rivoli, 75001 Paris, France</li>
            <li><strong>RCS</strong> : Paris — SIREN 000 000 000</li>
            <li><strong>N° TVA intracommunautaire</strong> : FR00 000000000</li>
            <li><strong>Directeur de la publication</strong> : La Direction de FlowMind AI</li>
            <li><strong>Contact</strong> : contact@flowmindai.eu</li>
          </ul>

          <h2 className="font-display text-2xl font-medium tracking-tight mt-10 mb-4">2. Hébergement</h2>
          <p className="text-zinc-700 leading-relaxed">
            L'infrastructure est hébergée au sein de l'Union Européenne (région eu-west-3, Paris).
            L'hébergeur garantit une infrastructure certifiée ISO 27001 et SOC 2 Type II.
          </p>

          <h2 className="font-display text-2xl font-medium tracking-tight mt-10 mb-4">3. Propriété intellectuelle</h2>
          <p className="text-zinc-700 leading-relaxed">
            L'ensemble des contenus présents sur ce site (textes, graphismes, logos, icônes, images, vidéos, sons,
            logiciels) sont la propriété exclusive de FlowMind AI SAS ou de ses partenaires. Toute reproduction,
            représentation, modification, publication ou adaptation, totale ou partielle, est interdite sans
            autorisation écrite préalable.
          </p>

          <h2 className="font-display text-2xl font-medium tracking-tight mt-10 mb-4">4. Limitation de responsabilité</h2>
          <p className="text-zinc-700 leading-relaxed">
            FlowMind AI s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site.
            Toutefois, FlowMind AI ne peut garantir l'exhaustivité ni l'absence d'erreur de ces informations et
            décline toute responsabilité en cas de dommage direct ou indirect résultant de leur utilisation.
          </p>

          <h2 className="font-display text-2xl font-medium tracking-tight mt-10 mb-4">5. Droit applicable</h2>
          <p className="text-zinc-700 leading-relaxed">
            Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux de
            Paris seront seuls compétents.
          </p>

          <h2 className="font-display text-2xl font-medium tracking-tight mt-10 mb-4">6. Contact</h2>
          <p className="text-zinc-700 leading-relaxed">
            Pour toute question : <strong>contact@flowmindai.eu</strong><br/>
            DPO (Délégué à la Protection des Données) : <strong>dpo@flowmindai.eu</strong>
          </p>
        </article>
      </section>
      <PublicFooter />
    </div>
  );
}
